export default __webpack_public_path__ + "static/media/bantuanBanjirFundraisingEng.66ae03c5.jpg";